/**
 * ResetScreen - 心理的リセット中間画面 (モック_GB組織_回答画面_v1.html s4 準拠)
 * Part3 (GBスキル) → Part4 (ONA基本) の遷移時にのみ表示し、
 * 自己診断から組織のつながりへのトーンシフトを案内する。
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ResetScreenProps {
  onConfirm: () => void;
}

export const ResetScreen: React.FC<ResetScreenProps> = ({ onConfirm }) => {
  const { t } = useTranslation();

  const renderLines = (text: string) =>
    text.split('\n').map((line, i) => (
      <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>
    ));

  return (
    <div className="gb74-reset">
      <div className="gb74-reset-icon">
        <svg width="40" height="40" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="18" fill="none" stroke="#3B6D11" strokeWidth="2" />
          <path d="M14 20h12M20 14v12" stroke="#3B6D11" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      <h2 className="gb74-reset-text">
        {renderLines(t('questionnaire.resetScreen.title', 'ここからは\n少し雰囲気が変わります'))}
      </h2>
      <p className="gb74-reset-sub">
        {renderLines(t('questionnaire.resetScreen.subtitle', 'あなたの周りの「つながり」について聞きます。\n先月の1か月を振り返ってください。'))}
      </p>
      <button type="button" className="gb74-next-btn" onClick={onConfirm}>
        {t('questionnaire.resetScreen.continue', '続ける')}
      </button>
    </div>
  );
};
